class Login {
  constructor(elem) {
    this.elem = elem;
	}

  initialize() {
    let link = this.elem.find('[data-registration-link]');

    link.on('click', () => {
      link.closest('[data-tabs-auth]').find('[data-tabs-head]').children().eq(1).trigger('click');

      setTimeout(() => {
        $('html, body').animate({scrollTop: '0px'}, 500);
      }, 300);
    });
  }
}

export {Login}

$(window).ready(function() {
  let login = [];

  if ($('[data-login').length > 0) {
		$('[data-login').each(function(i) {
			login[i] = new Login($(this));
			login[i].initialize();
		});
	}
});
